<template>
    <div class="freezed">
        Oops! Sorry, there's a problem with {{ problemWithComponent }} component. Our developers have been notified. Please try again later.
    </div>
</template>

<script>
const freezed = {
    name: 'freezed',
    props: {
        problemWithComponent: {
            default: false
        }
    }
};

export default freezed;
</script>
